import { useCallback, useEffect, useRef, useState } from 'react';
import { migrateMissionDocs } from '../../../../../../../../utils/missionDocMigration';

/**
 * Manual mission-notes transfer. Migration is NO LONGER automatic — the user
 * clicks "Transfer to a doc" on a mission that still has legacy embedded
 * content. On success writes attachedDocs + docsMigratedAt (via the caller);
 * legacy fields stay as frozen backups until explicitly cleared.
 */
export function useMissionDocMigration(task, taskId, onMissionDocsMigrated) {
  const [migrating, setMigrating] = useState(false);
  const inFlightRef = useRef(false);
  const onMigratedRef = useRef(onMissionDocsMigrated);
  onMigratedRef.current = onMissionDocsMigrated;

  // A fresh mission means any previous run is done — reset the guard.
  useEffect(() => {
    inFlightRef.current = false;
  }, [taskId]);

  const runMigration = useCallback(async () => {
    if (inFlightRef.current || !task) return;
    inFlightRef.current = true;
    setMigrating(true);
    try {
      const entries = await migrateMissionDocs(task);
      onMigratedRef.current?.(taskId, entries);
      if (entries.length > 0) {
        window.dispatchEvent(new CustomEvent('fokus:docs-changed'));
      }
    } catch (e) {
      console.error('Mission doc transfer failed:', e);
    } finally {
      inFlightRef.current = false;
      setMigrating(false);
    }
  }, [task, taskId]);

  return { migrating, runMigration };
}
